import alt from 'framework/alt';
import VerifiedProfileActions from 'actions/VerifiedProfileActions';

class VerifiedProfileStore {
  constructor() {
    this.state = {
      customerProfile: {},
      authorIdentity: {},
      claimedEntity: {},
      accountPool: {},
    };

    this.bindListeners({
      getProfileProperties: VerifiedProfileActions.fetchVerifiedProfileSucceeded,
      fail: [
        VerifiedProfileActions.fetchVerifiedProfileFailed,
        VerifiedProfileActions.fetchAuthorIdentityFailed,
        VerifiedProfileActions.fetchClaimedEntityFailed,
        VerifiedProfileActions.fetchAccountPoolFailed,
      ],
      getClaimedEntityProperties: VerifiedProfileActions.fetchClaimedEntitySucceeded,
      getAuthorProperties: VerifiedProfileActions.fetchAuthorIdentitySucceeded,
      getAccountPool: VerifiedProfileActions.fetchAccountPoolSucceeded,
    });
  }

  getProfileProperties(customerProfile) {
    this.setState({
      customerProfile,
      error: null,
    });
  }

  fail(error) {
    this.setState({ error });
  }

  getClaimedEntityProperties(claimedEntity) {
    this.setState({
      claimedEntity,
      error: null,
    });
  }

  getAuthorProperties(authorIdentity) {
    this.setState({
      authorIdentity,
      error: null,
    });
  }

  getAccountPool(accountPool) {
    this.setState({
      accountPool,
      error: null,
    });
  }
}

export default alt.createStore(VerifiedProfileStore, 'VerifiedProfileStore');
